import { Form } from '../core'

$.fn.ContactForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.contact-form', {
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('.header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        $('.contact-form').addClass('contact-form--blocked')
      },
      onSuccess: function() {
        self.closest('.row').css({
          'min-height': self.closest('.row').outerHeight(false),
          'display': 'flex',
          'align-items': 'center',
        })
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success text-xlarge">')
          $success.text('Votre message a été envoyé avec succès.').hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
        if ('gtag' in window) {
          gtag('event', 'form_submit', {
            'event_category': 'Contact Form',
            'event_label': 'Contact Form Submit',
          })
        }
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.contact-form').removeClass('contact-form--blocked')
          $('.contact-form .form-error--invisible').removeClass('form-error--invisible')
          $('.contact-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
